import script from "./MainMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenu.vue?vue&type=script&setup=true&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&id=e40460e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e40460e4"]])

export default __exports__